<template>
	<bsh-modal 
		titulo="Nova Categoria"
		:name="name">
		<template v-slot:default>
	        <categoria-produto-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </categoria-produto-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import CategoriaProduto from "./../../../models/CategoriaProduto.js";
	export default {
		data(){
			return {
				dados: new CategoriaProduto(),
				name: 'create_categ_produto',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+'/api/adm/categ-produtos/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new CategoriaProduto()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>